import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabase";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);

    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim().toLowerCase(), {
      redirectTo: `${window.location.origin}/update-password`,
    });

    setSubmitting(false);
    if (resetError) setError("We could not send a recovery email right now. Please wait a moment and try again.");
    else setMessage("If that email belongs to an active portal account, a secure password link is on its way. Check your spam folder if it does not arrive within a few minutes.");
  }

  return (
    <div className="screen centered">
      <form className="card form" onSubmit={handleSubmit}>
        <h1>Reset password</h1>
        <p id="reset-help">Enter the email address associated with your portal account. The link can be used once and expires for your protection.</p>
        {error ? <div className="error-block" role="alert">{error}</div> : null}
        {message ? <div className="info auth-message" role="status" aria-live="polite">{message}</div> : null}
        <label>
          Email
          <input type="email" inputMode="email" autoComplete="email" aria-describedby="reset-help" value={email} onChange={(event) => setEmail(event.target.value)} disabled={submitting} required />
        </label>
        <button type="submit" disabled={submitting}>{submitting ? "Sending secure link…" : "Send Secure Password Link"}</button>
        <Link className="auth-help-link" to="/login">Back to sign in</Link>
      </form>
    </div>
  );
}
